import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useApi } from "../../lib/api";
import { Decision } from "../Badges";

const COLOR = {
  "Morning Drive": "bg-amber-500/20 text-amber-300", Midday: "bg-sky-500/20 text-sky-300", Evening: "bg-purple-500/20 text-purple-300",
  Night: "bg-indigo-500/20 text-indigo-300", Weekend: "bg-teal-500/20 text-teal-300", Office: "bg-slate-500/20 text-slate-300",
  "On Call": "bg-emerald-500/15 text-emerald-300", Leave: "bg-fuchsia-500/20 text-fuchsia-300", Off: "text-slate-600",
};

const shiftWeek = (iso, d) => {
  const t = new Date(iso);
  t.setDate(t.getDate() + d);
  return t.toISOString().slice(0, 10);
};

export const Shifts = () => {
  const [start, setStart] = useState(null);
  const { data } = useApi(`/shifts${start ? `?start=${start}` : ""}`);
  if (!data) return <div className="font-data text-xs text-slate-500">Loading calendar…</div>;
  return (
    <div data-testid="shift-calendar">
      <div className="flex items-center gap-3 mb-4">
        <button className="btn-ghost !px-2" onClick={() => setStart(shiftWeek(data.week_start, -7))} data-testid="shift-prev-week"><ChevronLeft size={16} /></button>
        <div className="font-data text-sm text-ink" data-testid="shift-week-label">Week of {data.week_start}</div>
        <button className="btn-ghost !px-2" onClick={() => setStart(shiftWeek(data.week_start, 7))} data-testid="shift-next-week"><ChevronRight size={16} /></button>
      </div>
      <div className="overflow-x-auto panel">
        <table className="w-full text-xs min-w-[800px]">
          <thead>
            <tr className="border-b border-[color:var(--line)]">
              <th className="text-left p-3 text-slate-400 font-normal">Staff</th>
              {data.days.map((d) => (
                <th key={d.date} className={`p-3 text-left font-data font-normal ${d.holiday ? "text-gold" : "text-slate-400"}`} data-testid={`shift-day-${d.date}`}>
                  {new Date(d.date).toLocaleDateString("en-GB", { weekday: "short", day: "2-digit" })}
                  {d.holiday && <div className="text-[9px] normal-case">{d.holiday}</div>}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.rows.map((r) => (
              <tr key={r.staff_id} className="border-b border-[color:var(--line)]/50">
                <td className="p-3"><div className="text-ink">{r.name}</div><div className="text-[10px] text-slate-500">{r.station}</div></td>
                {r.cells.map((c) => (
                  <td key={c.date} className={`p-1.5 ${c.holiday ? "bg-[color:var(--gold)]/5" : ""}`}>
                    <span className={`block px-2 py-1.5 rounded-sm ${COLOR[c.shift] || ""}`}>{c.shift}</span>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-[11px] text-slate-500 mt-2">{data.holidays_note} Shift patterns are sample until HR rosters are imported.</p>
      <Decision>Spot holiday gaps and double-coverage before they hit air.</Decision>
    </div>
  );
};
